module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAMAAAAmuJTXAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABIUExURQAAAP///////////////////////////////////////////////////////////////////////////////////////////+d4eLAAAAAXdFJOUwAQID9AYGSApqvb3+Ll7e/w9fb4+f3+rdIQswAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAGJJREFUKFN9y9sOgCAMA9BNUVFQvO///9RhMLJJ7EPT5KQAWCPomIoLh+A02WUzzDORl2Qnoo4/jhRFiB9ALynC3txTUgaSBOSk4KUPPNR/IdFRgEQlYApEZwmYxrVN8y8AF1Q4B8zmXJCVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment/jtx_icon.png
// module id = Kysi
// module chunks = 1